import MenuItems from "../mobile-menu-item/mobile-menu-items.component";

import { MenuContainer } from "./mobile-menu.styles";

const MobileMenu = () => {
  return (
    <MenuContainer>
      <MenuItems />
    </MenuContainer>
  );
};

export default MobileMenu;
